import config from "./";
import { createInstance } from "@datapunt/matomo-tracker-react";

const instance = createInstance({
  urlBase: config.matomo.url,
  siteId: config.matomo.siteId
});

export default instance;
